import React from 'react'
import SliderBarDemo from './SliderBarDemo/index'
import BreakpointDemo from './BreakpointDemo/index'
import ExpandableDemo from './ExpandableDemo/ExpandableDemo'
import SocialButtonDemo from './SocialButtonDemo/index'
import HeadingDemo from './HeadingDemo/index'
import StyleDemo from './StyleDemo/index'
import ButtonDemo from './ButtonDemo/index'
import CardDemo from './CardDemo/index'
import IconDemo from './IconDemo/index'
import IconSvgDemo from './IconSvgDemo/index'
import FeedbackBoxDemo from './FeedbackBoxDemo/FeedbackBoxDemo'

function KitchenSink () {
  return (
    <div className="kitchen-sink">
      <HeadingDemo />
      <ButtonDemo />
      <IconSvgDemo />
      <IconDemo />
      <SliderBarDemo />
      <CardDemo />
      <BreakpointDemo />
      <SocialButtonDemo />
      <ExpandableDemo />
      <FeedbackBoxDemo />
      <StyleDemo />
    </div>
  )
}

export default KitchenSink
